export const numberKeys = <K extends number>(r: Record<K, any>): K[] => {
  return Object.keys(r).map((k) => parseInt(k, 10) as K);
};
